import { arrayOf, bool, number, oneOf, shape, string } from "prop-types";
import React from "react";

import styled from "styled-components";

import FnrIcon from "UI/FnrIcon";
import FnrTypography from "UI/FnrTypography";

import Campaign from "./Campaign";
import { KEYS } from "./const";

const getEraText = (era) => {
  switch (era) {
    case KEYS.CURRENT:
      return "There are no campaigns currently running.";
    case KEYS.PAST:
      return "There are no past campaigns to display.";
    case KEYS.FUTURE:
      return "There are no scheduled campaigns coming up.";
    default:
      return "";
  }
};

export default function CampaignList({ campaigns, era }) {
  const noCampaigns = Boolean(campaigns?.length === 0);

  if (noCampaigns) {
    return (
      <Column>
        <Card>
          <FnrTypography fontSize="lg" color="textLight">{`${getEraText(
            era
          )}`}</FnrTypography>

          <InfoSection>
            <SparklesIcon>
              <FnrIcon fas fa-sparkles />
            </SparklesIcon>
            <InfoText>
              <FnrTypography fontSize="lg" color="textLight">
                Start a new campaign for any fund to take pledges, track your
                progress, and more!{" "}
                <Link
                  href="https://help.flocknote.com/article/323-campaigns-and-pledge-tracking"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn more
                </Link>
                .
              </FnrTypography>
            </InfoText>
          </InfoSection>
        </Card>
      </Column>
    );
  }
  return (
    <Column>
      {campaigns.map((campaign) => (
        <Campaign key={campaign.ID} {...campaign} />
      ))}
    </Column>
  );
}

CampaignList.propTypes = {
  campaigns: arrayOf(
    shape({
      ID: number.isRequired,
      description: string.isRequired,
      earliestGiftDate: string,
      endDate: string.isRequired,
      givingTransactionFundID: number.isRequired,
      goal: number.isRequired,
      percentOfHouseholdsPledged: number,
      percentOfMaxDate: number.isRequired,
      pledgedAmountGiven: number.isRequired,
      pledgesCount: number,
      pledgesFulfilledCount: number,
      pledgesWithRecurringGiftCount: number,
      pledgingEnabled: bool.isRequired,
      startDate: string.isRequired,
      title: string.isRequired,
      totalPledge: number.isRequired,
      unpledgedAmountGiven: number.isRequired,
    })
  ).isRequired,
  era: oneOf([KEYS.CURRENT, KEYS.PAST, KEYS.FUTURE]).isRequired,
};

const Column = styled.div`
  display: grid;
  gap: 1rem;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  color: #eceff0;
  background-color: #384a5d;
  border-radius: 18px;
  padding: 1.5rem;
  box-sizing: border-box;
`;

const InfoSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1.5rem;
  position: relative;
`;

const SparklesIcon = styled.div`
  font-size: 1.5rem;
  color: #f3be4a;
  flex-shrink: 0;
`;

const InfoText = styled.div`
  flex: 1;
`;

const Link = styled.a`
  color: #eceff0;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
